const videoCodes = [
  'TlDrbm3B2R0',
  'heGAfbIDfA0',
  'Zn8gnW41nS0',
];

export const getRandomVideoCode = videoCodes[Math.floor(Math.random() * videoCodes.length)];
